import React from 'react'
import PropTypes from 'prop-types'

const PATH = 'M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5'
  + 'M16.5 7.5 12 3m0 0L7.5 7.5M12 3v13.5'

const UploadIcon = ({ className, title }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    aria-label={title}
  >
    <path
      d={PATH}
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

UploadIcon.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string
}

UploadIcon.defaultProps = {
  className: '',
  title: ''
}

export default UploadIcon
